
import Vue from 'vue'
import { VIcon } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcDataTableGroupIcon',
  components: { VIcon },
  props: {
    isOpen: { type: Boolean, required: true },
    center: { type: Boolean, default: false },
  },
})
